// export const BASE_URL = 'https://dev-api.wajenexus.com';              //dev server
export const BASE_URL = 'https://api.wajenexus.com';              //prodction server
// export const BASE_URL = 'https://freely-regardless-dogs-send.trycloudflare.com';              //ngrok local server
// export const BASE_URL = 'http://localhost:3000';         //local


export const API_URL = `${BASE_URL}/api/v1`;
export const EMAIL_DOMAIN = '@softswitch.teexponent.com';

export const firebaseConfig = {
    apiKey: "AIzaSyBG9UHNps7KaK7Ru9pw914Wm0mmsDFKWTI",
    authDomain: "fir-cloud-d28fe.firebaseapp.com",
    databaseURL: "https://fir-cloud-d28fe.firebaseio.com",
    projectId: "fir-cloud-d28fe",
    storageBucket: "fir-cloud-d28fe.firebasestorage.app",
    messagingSenderId: "908605692440",
    appId: "1:908605692440:web:260b7fce41bd264e03416d"
};

export const vapidKey = "BOycEIoZrDP2Z3P4sDPGmyaLJ2qrTdFGFZCHLO89Pwq5XOuvtTbrbQ31H2BLkpf602RIGs0bFsyU6xOl-D0EKng"

export const S3_URL = "https://softswitchbucket.s3.us-east-1.amazonaws.com";

//prod
export const DIALER_URL = "https://dial.wajenexus.com";
export const DIALER_ADMIN = { USER_NAME: "superadmin9", PASSWORD: "welcome2025" };

//dev
// export const DIALER_URL = "https://backupdial.wajenexus.com";
// export const DIALER_ADMIN = { USER_NAME: 6666, PASSWORD: "Welcome2026" };


export const MICROSOFT_CLIENT_ID = "6572e45d-4978-46d6-b0b6-f89df96603de";
export const MICROSOFT_TENANT_ID = "8900c5e2-270f-4ca0-9a2c-85889720d198";
//dev
// export const MICROSOFT_REDIRECT_URI = "https://dev-api.wajenexus.com/auth/microsoft/callback";

//prod
export const MICROSOFT_REDIRECT_URI="https://api.wajenexus.com/auth/microsoft/callback";